export default function genererCritereCommandeCommissions() {
  return {
    auto: null,
    societeId: null,
    commissionsNonValide: null,
    commercialId: [],
    commissionEtat: [],
    dates: {
      dateDebut: null,
      dateFin: null,
    },
    planMediaIds: [],
    referencesExternesCommandesIds: [],
    referencesExternesFacturesIds: [],
    avecAnnulations: true,
    typesReferenceExterne: null,
  };
}
